interface RouteDefinition {
  route: string;
  name?: string;
}

export const PRICING: RouteDefinition = {
  route: '/pricing',
  name: 'pricing-page',
};

export const USER_ONBOARDING: RouteDefinition = {
  route: '/payment/completed',
  name: 'user-onboarding',
};

export const SIGN_UP: RouteDefinition = {
  route: '/sign-up',
  name: 'sign-up-page',
};

export const ACCOUNT_PAYMENT: RouteDefinition = {
  route: '/account/payment',
  name: 'account-payment',
};

export const UPGRADE: RouteDefinition = {
  route: '/upgrade',
  name: 'upgrade',
};

export const PRO: RouteDefinition = {
  route: '/pro',
  name: 'pro-page',
};

export const REFERRAL: RouteDefinition = {
  route: '/account/referral',
  name: 'refer-friend',
};
